import { createI18n } from 'vue-i18n'
import Storage from '@/utils/storage'

// 导入中文语言包
import zhCommon from './locales/zh-CN/common.json'
import zhHeader from './locales/zh-CN/header.json'
import zhFooter from './locales/zh-CN/footer.json'
import zhLogin from './locales/zh-CN/login.json'
import zhHome from './locales/zh-CN/home.json'
import zhCourse from './locales/zh-CN/course.json'
import zhArticle from './locales/zh-CN/article.json'
import zhAudio from './locales/zh-CN/audio.json'
import zhOperation from './locales/zh-CN/operation.json'

// 导入日文语言包
import jaCommon from './locales/ja-JP/common.json'
import jaHeader from './locales/ja-JP/header.json'
import jaFooter from './locales/ja-JP/footer.json'
import jaLogin from './locales/ja-JP/login.json'
import jaHome from './locales/ja-JP/home.json'
import jaCourse from './locales/ja-JP/course.json'
import jaArticle from './locales/ja-JP/article.json'
import jaAudio from './locales/ja-JP/audio.json'
import jaOperation from './locales/ja-JP/operation.json'

// 合并各模块语言包
const buildMessages = (common, header, footer, login, home, course, article, audio, operation) => ({
  common,
  header,
  footer,
  login,
  home,
  course,
  article,
  audio,
  operation,
})

const messages = {
  'zh-CN': buildMessages(zhCommon, zhHeader, zhFooter, zhLogin, zhHome, zhCourse, zhArticle, zhAudio, zhOperation),
  'ja-JP': buildMessages(jaCommon, jaHeader, jaFooter, jaLogin, jaHome, jaCourse, jaArticle, jaAudio, jaOperation),
}

// 从 localStorage 读取语言偏好
const savedLocale = Storage.get('locale')
const defaultLocale = (savedLocale && ['zh-CN', 'ja-JP'].includes(savedLocale)) ? savedLocale : 'zh-CN'

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false,       // 使用 Composition API 模式
  locale: defaultLocale,
  fallbackLocale: 'zh-CN',
  messages,
  globalInjection: true, // 全局注入 $t
})

export default i18n
